<template>
  <div>
    <el-dialog width="90%" title="箱唛检查" :visible.sync="visible" @close="close">
      <div style="text-align: left;">
        <div style="font-weight: bolder; font-size: 18px;"><span style="margin-right: 10px;">国际发货单号：{{ code }}</span>
          <span>箱子数：{{ dataSource?.length }}</span>
        </div>
        <div style="color: crimson;margin-top: 10px;">注：如果箱唛序号与箱子序号或重量及体积不一致，则会标记为异常，需要检查箱子中商品是否一致，并按照序号将箱唛贴在对应箱子上。
        </div>
      </div>
      <WmsTable :rowClassFunc="rowClassFunc" :scroll="false" style="margin-top: 10px;" :hasHeader="false"
        :columns="columns" :dataSource="dataSource" :isPagination="false">
        <template slot="nums" slot-scope="{ text, record }">
          <el-link type="primary" @click="showDetail(record)">{{ text }}</el-link>
        </template>
      </WmsTable>
      <el-dialog width="80%" title="商品明细" :visible.sync="detailVisible" append-to-body>
        <WmsTable :scroll="false" :hasHeader="false" :columns="detailColumns" :dataSource="detailSource"
          :isPagination="false">
        </WmsTable>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import {
  fbaCheckBoxMark
} from "@/apis/outStock";
export default {
  components: {
    WmsTable
  },
  emits: ['close'],
  data() {
    return {
      code: '',
      visible: false,
      detailColumns: [
        {
          title: "msku",
          dataIndex: "msku",
        }, {
          title: "件数",
          dataIndex: "nums",
        }, {
          title: "fnsku",
          dataIndex: "fnsku",
        }, {
          title: "asin",
          dataIndex: "asin",
        }, {
          title: "商品SKU",
          dataIndex: "shopProductSku",
        }, {
          title: "平台SKU",
          dataIndex: "productSku",
        }
      ],
      columns: [
        {
          title: "箱唛序号",
          dataIndex: "platformOrderNo",
          customRender: (t, r, i) => {
            return i + 1
          }
        }, {
          title: "亚马逊箱唛",
          dataIndex: "boxMark",
        }, {
          title: "箱子编号",
          dataIndex: "boxSerial",
        }, {
          title: "重量（kg）",
          dataIndex: "weight",
        }, {
          title: "长宽高(cm)",
          dataIndex: "length",
          customRender: (t, r) => {
            return `${r.length}*${r.width}*${r.height}`
          }
        }, {
          title: "商品件数",
          dataIndex: "nums",
          scopedSlots: {
            customRender: "nums",
          },
        }, {
          title: "是否异常",
          dataIndex: "abnormal",
          customRender: (t) => {
            return t ? '是' : '否'
          }
        }
      ],
      dataSource: [],
      detailSource: [],
      detailVisible: false
    }
  },
  methods: {
    close() {
      this.visible = false
      this.detailVisible = false
      this.$emit('close')
    },
    rowClassFunc(record, index) {
      // console.log(params);
      if (record.abnormal) {
        return 'abnormal'
      }
    },
    async show(code) {
      this.code = code
      this.visible = true
      this.dataSource = []
      const res = await fbaCheckBoxMark({
        deliveryTaskCode: code
      })
      this.dataSource = res.data
    },
    showDetail(record) {
      this.detailSource = record.fbaCheckBoxItemDTOList
      this.detailVisible = true
    }
  }
}
</script>

<style lang="less">
.ant-table {
  .abnormal {
    background: rgba(245, 34, 45, .3);
  }
}
</style>